module.exports = __webpack_public_path__ + "static/media/pga-logo.8354af0e.png";